// extracted by mini-css-extract-plugin
export default {"loginButton":"button_loginButton__wsrd+","createAccount":"button_createAccount__jgf8R"};